import type { RenderSystem } from "@engine/core/Lifecycle";
import type { EcsWorld } from "../world";

/**
 * The single ECS → Pixi bridge. Reads entity `position` (and `heading`)
 * and writes it onto the entity's `sprite.container`. Nothing else should
 * touch sprite transforms directly.
 */
export class RenderSyncSystem implements RenderSystem {
  private query;

  constructor(world: EcsWorld) {
    this.query = world.with("position", "sprite");
  }

  render(_alpha: number): void {
    for (const e of this.query) {
      e.sprite.container.position.set(e.position.x, e.position.y);
      if (typeof e.heading === "number" && !e.sprite.lockRotation) {
        e.sprite.container.rotation = e.heading;
      }
    }
  }
}
